// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Bank account information
*/
export class DigitalpaymentBankAccountDetail {
    'accountNumberLastFour'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DigitalpaymentBankAccountDetail>> = [
        {
            "name":     "accountNumberLastFour",
            "baseName": "accountNumberLastFour",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DigitalpaymentBankAccountDetail.attributeTypeMap;
    }
}
